// extracted by mini-css-extract-plugin
export default {"bottom":"Content_bottom__+za6E","text":"Content_text__gFioE"};